// Clairessence PubSub
const subscribers = {};
export function subscribe(eventName, callback) {
    if (!subscribers[eventName]) subscribers[eventName] = [];
    subscribers[eventName].push(callback);
}
export function publish(eventName, data) {
    if (subscribers[eventName]) {
        subscribers[eventName].forEach(callback => callback(data));
    }
}
